import React, { Component } from 'react'
import * as actions from '../actions'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { parseEntityId } from '../../../models/entity'
import { Card, Button, Col, Row, Alert } from 'react-bootstrap'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Dialog } from '@material-ui/core'
import MuiTable from '../../Forms/SharedComponents/containers/MuiTable'
import { FORM_EDICION_COEM } from '../../../config/forms'
import { TABLA_COEMS, TABLA_COEMS_FINALIZADOS } from '../../../config/tables'
import DialogoCOEMsAdd from './DialogoCOEMsAdd'

class DialogoCOEMsView extends Component {
  componentDidMount () {
    const { id, onlyView } = this.props
    // this.props.getCoemsPorCaratula(id)
    this.props.getConsultaDatosCaratula(id)
    // Actualizar los datos de Exportadores
    this.props.actualizarExportadoresEnFormulario(id)
    if (!onlyView) {
      this.props.actualizarDatosCoemsParaMuiTable(id)
    } else {
      this.props.actualizarDatosCoemsFinalizadosParaMuiTable(id)
    }
  }

  render () {
    const {
      handleClose,
      handleSubmit,
      consultaCaratula,
      openAddCoem,
      setOpenDialogCoem,
      codigoAduana,
      idAduana,
      mensajeAduana,
      isRequestingSoap,
      onlyView,
      selectedExportador
    } = this.props

    const handleCloseDialog = () => {
      setOpenDialogCoem(false)
    }

    const renderExportadores = () => {
      const {
        caratulaExportador
      } = this.props
    
      const options = caratulaExportador.map((exportador, index) => {

        return (
          <option
            value={parseEntityId(exportador)}
            key={index + 1}
          >
            {exportador}
          </option>
        )
      })
      options.unshift((<option value={null} key={0} />))
      return options
    }

    const onSelect = (exportador) => {
      // const label = options[options.selectedIndex].label
      if (exportador) {
        console.log('Exportador Selecionado', exportador.target.value)
        this.props.actualizarExportadorSelecionado(exportador.target.value)
      }
    }

    return (
      <div>
        <Dialog
          open={openAddCoem}
          onClose={handleCloseDialog}
          fullWidth
          maxWidth='sm'>
          <DialogoCOEMsAdd 
            handleClose={handleCloseDialog} 
            handleSubmit={handleSubmit} 
            renderExportadores={renderExportadores}
            onSelect={onSelect}
            selectedExportador={selectedExportador}
          />
        </Dialog>
        <Card style={{ border: 'none' }}>
          <Card.Header style={{ backgroundColor: '#3f51b5', color: '#ffffff' }}>
            <Card.Text style={{ fontSize: '1.3rem', textAlign: 'center' }}>Lista de COEMs</Card.Text>
          </Card.Header>
          <Card.Body>
            <div>
              {consultaCaratula && <div>
                <Row>
                  <Col md={6}>
                    <span style={{ fontSize: 'large' }}>Buque: </span>
                    <span style={{ fontWeight: 'bold', fontSize: 'large' }}>{consultaCaratula.nombreBuque}</span>
                  </Col>
                  <Col md={6}>
                    <span style={{ fontSize: 'large' }}>Id. Carátula: </span>
                    <span style={{ fontWeight: 'bold', fontSize: 'large' }}>{consultaCaratula.identificadorCaratula}</span>
                  </Col>
                </Row>
                <br />
              </div> }
              {(codigoAduana && mensajeAduana) && (<div className='circular-progress-consulta-soap'>
                <Row>
                  <Alert fade show variant='secondary'>
                    <Alert.Heading>Atención!!!</Alert.Heading>
                    <p style={{ fontSize: 'medium' }}>Código: <strong>{codigoAduana}</strong></p>
                    <p style={{ fontSize: 'medium' }}>Descripción: <strong>{mensajeAduana}</strong></p>
                    {idAduana && <p style={{ fontSize: 'medium' }}>Identificador de Aduana: {idAduana}</p>}
                  </Alert>
                </Row>
                <br />
              </div>)}
              {(isRequestingSoap) && <div className='circular-progress-consulta-soap'>
                <CircularProgress thickness='5' size='5rem' style={{ margin: '0 auto' }} />
              </div>}
              {(!onlyView) && <MuiTable id={TABLA_COEMS} />}
              {(onlyView) && <MuiTable id={TABLA_COEMS_FINALIZADOS} />}
            </div>
          </Card.Body>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button style={{ margin: '2%' }} onClick={handleClose} >Cerrar</Button>
          </div>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    consultaCoem: state.comunicacionEmbarque.consultaCoem,
    selectedExportador: state.comunicacionEmbarque.selectedExportador,
    consultaCaratula: state.comunicacionEmbarque.consultaCaratula,
    caratulaExportador: state.comunicacionEmbarque.caratulaExportador,
    openAddCoem: state.comunicacionEmbarque.openAddCoem,
    codigoAduana: state.comunicacionEmbarque.codigoAduana,
    idAduana: state.comunicacionEmbarque.idAduana,
    mensajeAduana: state.comunicacionEmbarque.mensajeAduana,
    isRequestingSoap: state.comunicacionEmbarque.isRequestingSoap
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_EDICION_COEM,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(DialogoCOEMsView))
